import React from "react";
import { useCompanyDashboard } from "../../Hooks/useCompanyDashboard";

export default function TodaysAppointments() {
    const { quotesSummary, isLoading, isError } = useCompanyDashboard();

    if (isLoading) {
        return (
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 animate-pulse">
                <div className="h-8 bg-gray-200 rounded w-48 mb-5" />
                <div className="grid grid-cols-5 gap-4 mb-6">
                    {[...Array(5)].map((_, i) => (
                        <div key={i} className="h-16 bg-gray-200 rounded" />
                    ))}
                </div>
            </div>
        );
    }

    if (isError) {
        return (
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 text-center text-red-600">
                Failed to load today's appointments.
            </div>
        );
    }

    const today = quotesSummary.quotes_accepted_today;
    const completed = quotesSummary.quotes_with_completed_jobs;
    const remaining = quotesSummary.quotes_remaining;

    return (
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-5">Today's Quotes Summary</h3>

            <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 mb-6">
                <div className="text-center">
                    <p className="text-sm text-gray-600">Total Today</p>
                    <p className="text-2xl font-bold text-gray-900">${today.formatted_amount}</p>
                </div>
                <div className="text-center">
                    <p className="text-sm text-gray-600">Accepted</p>
                    <p className="text-2xl font-bold text-emerald-600">{today.count}</p>
                </div>
                <div className="text-center">
                    <p className="text-sm text-gray-600">Completed</p>
                    <p className="text-2xl font-bold text-gray-900">{completed.count}</p>
                </div>
                <div className="text-center">
                    <p className="text-sm text-gray-600">Remaining</p>
                    <p className="text-2xl font-bold text-[#1665f6]">{remaining.count}</p>
                </div>
            </div>

            <div className="flex flex-col gap-4">
                <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-2xl p-5 text-white shadow-lg text-center">
                    <p className="text-3xl font-bold">{today.count}</p>
                    <p className="text-sm opacity-90 mt-1">ACCEPTED TODAY</p>
                    <p className="text-xs mt-2 opacity-80">${today.formatted_amount}</p>
                </div>

                <div className="bg-gradient-to-r from-[#1665f6] to-[#0d51d4] rounded-2xl p-5 text-white shadow-lg text-center">
                    <p className="text-3xl font-bold">{remaining.count}</p>
                    <p className="text-sm opacity-90 mt-1">REMAINING</p>
                    <p className="text-xs mt-2 opacity-80">${remaining.formatted_amount}</p>
                </div>

                <div className="bg-gradient-to-r from-gray-500 to-gray-600 rounded-2xl p-5 text-white shadow-lg text-center">
                    <p className="text-3xl font-bold">{completed.count}</p>
                    <p className="text-sm opacity-90 mt-1">COMPLETED</p>
                    <p className="text-xs mt-2 opacity-80">${completed.formatted_amount}</p>
                </div>
            </div>
        </div>
    );
}